import { SlashCommand } from './types';

export const justRemoveCommands: SlashCommand[] = [
    {
        id: 'jr-remove',
        trigger: '/remove',
        name: 'Digital Footprint Scan',
        description: 'Scan online platforms to identify the digital footprint of a username or name.',
        category: 'PRIVACY',
        icon: 'fas fa-search-location',
        mode: 'prompt',
        integration: 'JustRemove.me'
    },
    {
        id: 'jr-optout',
        trigger: '/optout',
        name: 'Automated Opt-Out',
        description: 'Automate an opt-out or data removal request from a specific data broker.',
        category: 'PRIVACY',
        icon: 'fas fa-user-shield',
        mode: 'prompt',
        integration: 'JustRemove.me'
    }
];
